import AuthService from './AuthService'
import {
  addNextSteps,
  handleVideo,
  handleDate,
  formatMessage,
  formatVariable,
  formatFormData,
  checkFileSize,
} from './validateResponse'

const Auth = new AuthService()

const handleFile = (file, stepName, fileType, stepId, candidateId) => {
  const formData = new FormData()
  formData.append('uri', file)
  formData.append('name', stepName)
  formData.append('stepId', stepId)
  formData.append('type', fileType)
  formData.append('candidateId', candidateId)

  return Auth.fetch('/lambda-candidate-file', {
    method: 'POST',
    body: formData,
  })
}

/**
 *
 * @param dto
 * @param success
 * @param error
 * @returns {Promise<void|*>}
 */
export default async function (dto, success, error) {
  try {
    if (dto.tag.type === 'select' && dto.tag?.value[0] === 'playVideo') {
      return handleVideo(dto.tag.id, this, success, error)
    }

    await this.setState({
      formData: formatFormData(this.cf.getFormData(true), this.state.rawSteps),
      messagesToSave: [...this.state.messagesToSave, ...formatMessage(dto)],
      rawVariablesById: {
        ...this.state.rawVariablesById,
        ...{
          [`var-${dto.tag.id}`]: formatVariable(dto, this.state.rawSteps),
        },
      },
      newRawVariablesById: {
        ...this.state.newRawVariablesById,
        ...{
          [`var-${dto.tag.id}`]: formatVariable(dto, this.state.rawSteps),
        },
      },
    })

    if (this.props.preview) {
      addNextSteps(this)
      return success()
    }

    const params = {
      messages: this.state.messagesToSave,
      variablesById: this.state.newRawVariablesById,
      lastStepId: dto.tag.id,
    }

    const { reactivationId } = this.state
    const stepId = dto.tag.id
    const { type } = dto.tag

    const stepIndex = this.state.rawSteps
      .map((step) => step._id)
      .indexOf(stepId)
    const step = this.state.rawSteps[stepIndex]

    if (step?.requirement === 'Statut') {
      const optionIndex = step.options
        .map((e) => e._id)
        .indexOf(dto.tag?.value[0])
      params.researchStatus = step.options[optionIndex].value
    }

    if (step?.requirement === 'Platform') {
      const optionIndex = step.options
        .map((e) => e._id)
        .indexOf(dto.tag?.value[0])
      params.selectedPlatform = step.options[optionIndex].value
    }

    if (step?.requirement === 'Frequency') {
      const optionIndex = step.options
        .map((e) => e._id)
        .indexOf(dto.tag?.value[0])
      params.selectedFrequency = step.options[optionIndex].value
    }

    if (step?.requirement === 'Birthday') {
      const date = await handleDate(dto.text, true)

      const { status, message, value } = date

      if (!status) {
        return error(message || this.props.sentences.invalidDate)
      }

      params.birthdayDate = value
    }

    if (type === 'file') {
      const { files } = dto.tag.domElement

      const file = files[0]

      if (!checkFileSize(file)) {
        this.toggleError()
        return error()
      }

      const { requirement } = step

      let fileType = 'other'

      if (requirement === 'CV') {
        fileType = 'resume'
      }

      try {
        const savedFile = await handleFile(
          file,
          step.name,
          fileType,
          stepId,
          this.props.candidateId,
        )

        if (!(savedFile.id && savedFile.successfulSave)) {
          throw new Error("L'enregistrement du fichier a échoué")
        }
      } catch (err) {
        this.toggleError()
        if (err.message === 'Received file format is not accepted') {
          return error("Ce format de fichier n'est pas accepté")
        }

        return error(err.message)
      }
    }
    await Auth.fetch('/lambda-interaction-reactivation', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...params,
        candidateId: this.props.candidateId,
        reactivationId,
      }),
    })
    this.setState({
      messagesToSave: [],
      newRawVariablesById: {},
    })
    addNextSteps(this)
    success()
  } catch (e) {
    success()
    this.cf.addRobotChatResponse(
      'Une erreur est survenue &#128542;. Revenez dans quelques instants pour poursuivre notre discussion !',
    )
    return this.cf.flowManager.stop()
  }
}
